import {
  Alert,
  Paper,
  Box,
  Typography,
  useMediaQuery,
  TextField,
  Stack,
  IconButton,
} from "@mui/material";
import StartIcon from "@mui/icons-material/Start";
import React, { useState } from "react";
import { scanToolLogin } from "../api/scan-tool.api";
import lang from "../i18n/lang";

function LoginScanApp({
  token,
  setToken,
}: {
  token: string;
  setToken: React.Dispatch<React.SetStateAction<string>>;
}) {
  const isWideScreen = useMediaQuery("(min-width: 1000px)");
  const style = {
    marginTop: "3.5em",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 1,
    bgcolor: "#FFFFFF",
    width: isWideScreen ? "40%" : "100%",
    height: isWideScreen ? "40%" : "100%",
  };
  const [scanPin, setScanPin] = useState("");
  const [error, setError] = useState("");
  const scanPinSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const result = await scanToolLogin(scanPin);
      if (result) {
        setToken(result.token);
      }
    } catch (err: unknown) {
      if (err instanceof Error && err.message === "INVALID_PIN") {
        setError(lang("scan.error.invalid.pin"));
      } else {
        setError(lang("scan.error.generic"));
      }
    }
  };

  return (
    <Paper sx={style} elevation={5}>
      <Box display="flex" p={3}>
        <Stack spacing={3}>
          <Typography
            align="left"
            variant="h4"
            sx={{ fontWeight: "600", color: "#00537D" }}
          >
            {lang("scan.pin")}
          </Typography>
          <Box display="flex" alignContent="left">
            <form onSubmit={scanPinSubmit}>
              <TextField
                error={!!error}
                value={scanPin}
                label={lang("scan.pin.enter")}
                type="tel"
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                onChange={(e) => setScanPin(e.target.value.trim())}
              />
              <IconButton type="submit" size="large" color="primary">
                <StartIcon />
              </IconButton>
            </form>
          </Box>
          {error && <Alert severity="error">{error}</Alert>}
          <Alert severity="info">{lang("scan.pin.info")}</Alert>
        </Stack>
      </Box>
    </Paper>
  );
}

export default LoginScanApp;
